
var SEARCH_DOM = {
    // 重置搜索页面的样式
    updateSearchPageStyle() {
        var titleDiv = document.getElementsByClassName('search-layout-title-bar')[0],
            contentDiv = document.getElementsByClassName('search-layout-content')[0],
            resultDiv = document.getElementsByClassName('search-result-list')[0];
        if(contentDiv){
            contentDiv.style = 'padding-top: ' + titleDiv.clientHeight + 'px';
        }
        if(resultDiv){
            resultDiv.style = 'padding-top: ' + titleDiv.clientHeight + 'px';
            resultDiv.style.height = window.innerHeight + 'px';
        }
        var resultList = document.getElementById('SearchList');
        if(resultList) {
            resultList.style.height = (window.innerHeight - titleDiv.clientHeight) + 'px';
        }
    },
    // 重置高级搜索页面的样式
    updateAdvancedSearchPageStyle() {
        var topDom = document.getElementsByClassName('title-bar')[0],
            boxDom = document.getElementsByClassName('layout-advanced-search-box')[0],
            titleDom = document.getElementsByClassName('layout-asb-title')[0],
            listDiv = document.getElementsByClassName('advanced-search-list')[0],
            listDom = document.getElementById('AdvancedSearchResultList');
        var curHeight = (topDom && boxDom) ? (innerHeight - topDom.clientHeight - boxDom.clientHeight) : innerHeight;
        listDiv.style.height = curHeight + 'px';
        if(listDom && titleDom) {
            listDom.style.height = (curHeight - titleDom.clientHeight) + 'px';
        }
    }
}

export {
    SEARCH_DOM
}